import Banner from "../components/Banner/Banner";
import PostBanner from "../components/PostBanner";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { User } from "../types/slice.types";

export default function Home() {
  const user = useSelector((state: RootState) => state?.auth?.user) as User;

  return (
    <div className="p-6 text-center animate-fade-in-up">
      <Banner username={user?.name} />
      <PostBanner />
    </div>
  );
}
